/** Build comment/badge author profile from /me/profile + shop catalog. */
import { formatUserFullName } from "./profileNames";

export function buildViewerAuthorProfile(profile, shopCatalog) {
  if (!profile?.email) return null;
  const email = profile.email;
  const displayName =
    profile.displayName || formatUserFullName(profile.firstName, profile.lastName, email) || email;
  let avatarUrl = profile.profileIconDataUrl || null;
  let avatarAuraClass = null;
  let usernameStyleClass = null;
  const owned = new Set(Array.isArray(profile.marketplaceOwned) ? profile.marketplaceOwned : []);
  const catalog = Array.isArray(shopCatalog) ? shopCatalog : [];

  if (profile.equippedAvatarCosmeticId && owned.has(profile.equippedAvatarCosmeticId)) {
    const item = catalog.find((i) => i.id === profile.equippedAvatarCosmeticId);
    if (item?.type === "avatar" && item.imageDataUrl) {
      avatarUrl = item.imageDataUrl;
      avatarAuraClass = item.auraClass || null;
    }
  }
  if (profile.equippedUsernameStyleId && owned.has(profile.equippedUsernameStyleId)) {
    const item = catalog.find((i) => i.id === profile.equippedUsernameStyleId);
    if (item?.cssClass) usernameStyleClass = item.cssClass;
  }

  return {
    email,
    firstName: profile.firstName || "",
    lastName: profile.lastName || "",
    displayName,
    avatarUrl,
    avatarAuraClass,
    usernameStyleClass,
  };
}
